/*
 * @Description: 
 * @Version: 2.0
 * @Autor: YGQ
 * @Date: 2024-02-26 14:17:04
 * @LastEditors: YGQ
 * @LastEditTime: 2024-11-22 15:07:48
 */
import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import request from "./api/request.js"; // 封装的 http 请求方法
import elApi from "./api/element.js"; // 封装的全局element方法
import aegis from "./aegisWebSdk.JS"; // 腾讯云前端监控接入
import forage from "@/utils/forage";

import ElementPlus from 'element-plus'
import zhCn from 'element-plus/dist/locale/zh-cn.mjs'
import "./styles/index.scss"; // 全局样式库

import "@/svgIcon/index"
import svgIcon from "@/svgIcon/index.vue";
import VueScrollTo from 'vue-scrollto';
import 'element-plus/theme-chalk/display.css'


/* 引入aos动画库相关文件 */
import AOS from 'aos'
import 'aos/dist/aos.css'

import VueAwesomeSwiper from 'vue-awesome-swiper';
import 'swiper/css';

const app = createApp(App)

// 全局注册 vue-scrollto 插件

/* aos动画初始化 */
AOS.init({
  duration: 1000,
  easing: "ease-in-out",
  initClassName: 'aos-init', // 默认初始化类
  animatedClassName: 'aos-animate', // 默认动画类
  mirror: false
});

app.config.globalProperties.$aegis = aegis;

app.component('svg-icon', svgIcon)

app.use(VueAwesomeSwiper);
app.use(VueScrollTo);
app.use(router)
app.use(elApi)
app.use(request)
app.use(forage)
app.use(ElementPlus, { locale: zhCn })
app.mount('#app')
